<template>
  <div class="popup-content">
    <!-- <transition v-on:enter="enter" v-on:leave="leave"> -->
      <!-- <div class="loading" v-if="editLoading">
        <div class="loading-enc-edit">
          <svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
            <circle cx="170" cy="170" r="160" stroke="#4E53E7"/>
            <circle cx="170" cy="170" r="135" stroke="#404041"/>
            <circle cx="170" cy="170" r="110" stroke="#4E53E7"/>
            <circle cx="170" cy="170" r="85" stroke="#404041"/>
          </svg>
        </div>
      </div> -->
      <div class="popup-add" v-if="!isDownload && !isCreate && !editLoading">
        <div class="popup-header">
          <h4 class="title">Добавить участок</h4>
          <a href="https://rrdoc.ru" target="_blank">Заказать выписки</a>
        </div>
        <p class="subtitle">Выберите способ добавления земельного участка</p>
        <div class="add-content">
          <div class="option" @click="isDownload = true">
            <img src="@img/open.svg" alt="">
            <p>Загрузить из документа Росреестра</p>
          </div>
          <div class="option" @click="isCreate = true">
            <img src="@img/big-plus.svg" alt="">
            <p>Создать вручную</p>
          </div>
        </div>
      </div>
    <!-- </transition> -->
    <!-- <transition v-on:enter="enter" v-on:leave="leave"> -->
      <PopupDownloadVue v-if="isDownload" @cancelDownload="isDownload = false"></PopupDownloadVue>
    <!-- </transition> -->
    <!-- <transition v-on:enter="enter" v-on:leave="leave"> -->
      <PopupCreateVue v-if="isCreate" :mode="mode" :pk="pkToEdit" @cancelCreate="isCreate = false"></PopupCreateVue>
    <!-- </transition> -->
  </div>
</template>

<script>
import { TimelineMax, TweenMax, Power4 } from 'gsap'
import PopupDownloadVue from './PopupDownloadVue.vue'
import PopupCreateVue from './PopupCreateVue.vue'
import { eventBus } from '@/main.js'

export default {
  components: {
    PopupDownloadVue,
    PopupCreateVue
  },
  data () {
    return {
      isDownload: false,
      isCreate: false,
      mode: 'create',
      pkToEdit: null
    }
  },
  computed: {
    editLoading () {
      return this.$store.getters.value('editLoading')
    }
  },
  created () {
    eventBus.$on('openEdit', this.openEdit)
  },
  beforeDestroy () {
    eventBus.$off('openEdit')
  },
  methods: {
    openEdit (pk) {
      this.mode = 'edit'
      this.pkToEdit = pk
      this.isCreate = true
    },

    enter (el, done) {
      const tl = new TimelineMax({
        onComplete: done
      })
      tl.set(el, {
        x: window.innerWidth * 1.5,
        scale: 0.8,
        transformOrigin: '50% 50%'
      })
      tl.to(el, 0.5, {
        x: 0,
        ease: Power4.easeOut
      })
      tl.to(el, 1, {
        scale: 1,
        ease: Power4.easeOut
      })
    },
    leave (el, done) {
      TweenMax.fromTo(el, 1, {
        autoAlpha: 1
      }, {
        autoAlpha: 0,
        ease: Power4.easeOut,
        onComplete: done
      })
    }
  }
}
</script>

<style lang="scss">
.popup-fade-enter-active,
.popup-fade-leave-active {
  transition: all .3s;
}
.popup-fade-enter,
.popup-fade-leave-to {
  transform: translateX(-1000px);
  height: 0;
  opacity: 0;
}

.popup-show-enter-active,
.popup-show-leave-active {
  transition: all .3s;
}
.popup-show-enter,
.popup-show-leave-to {
  transform: translateX(1000px);
  height: 0;
  opacity: 0;
}

.popup-add {
  padding: 35px 0 35px 50px;
}

.add-content {
  display: flex;
  justify-content: space-between;
  .option {
    text-align: center;
    padding-top: 15px;
    width: 210px;
    height: 130px;
    border-radius: 8px;
    border: 1px solid #e6e6e6;
    cursor: pointer;
    transition: .3s;
    img {
      margin-bottom: 10px;
    }
    &:hover {
      border-color: #4E53E7;
    }
    &:first-child {
      margin-right: 10px;
    }
  }
}
.loading-enc-edit {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 150px;
  height: 150px;
  .loader {
    margin-top: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PopupAddVue.vue